package org.abhranilnxt.portfolio.models

enum class Experience(
    val number: String,
    val jobPosition: String,
    val description: String,
    val company: String,
    val from: String,
    val to: String
) {
    First(
        number = "01",
        jobPosition = "Team Lead (Android)",
        description = "Leading a team of 15+ Android Developers in our organisation. Managing various projects, ensuring the implementation of the latest practices and encouraging Cross-Domain Collaboration.",
        company = "IoT Lab KIIT",
        from = "March 2023",
        to = "Present"
    ),
    Second(
        number = "02",
        jobPosition = "Android Testing/Deployment Intern",
        description = "Aided in testing their Android Application which was connected to their Smart Garbage Collection Robot. Assisted in deploying the application to Google Play Store.",
        company = "TechiEco Solutions Private Limited",
        from = "April 2024",
        to = "July 2024"
    ),
    Third(
        number = "03",
        jobPosition = "Android Developer Intern",
        description = "Aided in developing the Android Application port from iOS. Created the Profile Screen and implemented features in it. Implemented an Achievements functionality in the app. Migrated and implemented the app login to Firebase Email Authentication.",
        company = "Chamberly AB",
        from = "April 2024",
        to = "August 2024"
    )
}